<template>
  <div class="storePage">
    <section class="main">
      <!-- 员工风采 -->
      <div class="develop">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">STORE SEARCH</div>
            <div class="title2">门店查询</div>
          </div>
        </div>
        <div class="inpbox">
          <el-input placeholder="请填写门店名称" v-model="form.name" clearable class="input1"></el-input>
          <el-button class="btn" @click="search">查询</el-button>
        </div>

        <div class="inpbox">
          <el-select v-model="form.province" clearable placeholder="请选择省份" class="select" @change="selectProvimce">
            <el-option
              v-for="item in provincearr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-select v-model="form.city" clearable placeholder="选择城市" class="select" @change="selectcity">
            <el-option
              v-for="item in cityarr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-input placeholder="地址" v-model="form.address" clearable class="input2"></el-input>
        </div>

        <div class="storelist">
          <el-table :data="list" style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="门店名称" width="280"></el-table-column>
            <el-table-column prop="address" label="门店地址"></el-table-column>
            <!-- <el-table-column prop="address" label width="180">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="btns">详情</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination background layout="prev,pager, next,jumper" :total="total" v-show="total>0"
			@current-change="handleCurrentChange"></el-pagination>
        </div>
        <!-- 门店数据更新时间备注 -->
        <div class="data-update-note">
          <p class="note-title">* 数据提示</p>
          <p class="note-text">门店数据更新于 2026 年 7 月，与当前实际情况可能存在差异。</p>
          <p class="note-detail">差异表现：部分门店可能已<strong>停业、搬迁或更名</strong>，门店地址也可能随之变动，新开门店尚未收录。</p>
          <p class="note-detail">对比结果：请以<strong>门店现场实际公示</strong>及官方最新公告为准，本页信息仅供参考。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {province} from '../utils/map.js'
import {storeList,storequery} from '../api/index.js'
export default {
  data() {
    return {
      input1: "",
      input2: "",
      list: [],
      provincearr:[],
      provinceValue:'',
      cityValue:'',
      cityarr:[],
      total:0,
      loading:true,
      pageNum:1,
      form:{
        storeNo:'',
        name:'',
        province:'',
        address:'',
        city:'',
      }
    };
  },
  created(){
    this.provincearr = province;
    this.getList();
  },
  methods:{
    search(){
      this.pageNum=1;
      this.getList();
      console.log(this.form)
    },
    getList(){
      this.loading=true;
      let param={
        pageNum:this.pageNum,
        pageSize:10,
        storeNo:'',
        name:this.form.name,
        province:this.form.province,
        address:this.form.address,
        city:this.form.city,
      }
      storequery(param).then(res=>{
        console.log(res)
        if(res.resultCode=='0'){
          this.list=res.data.list;
          this.total=res.data.total;
        }
        this.loading=false;
      })
    },
    selectProvimce (id) {
      this.cityarr = [];
      this.form.city = "";
      console.log(id)
      for (let item of this.provincearr) {
        if (id == item.name) {
          console.log(item)
          this.cityarr = item.children
        }
      }
    },
    selectcity (id) {
      // this.regionarr = [];
      // this.RegionValue = '';
      // for (let item of this.cityarr) {
      //   if (id == item.id) {
      //     this.regionarr = item.children
      //   }
      // }

    },
    handleCurrentChange(val) {
      console.log(val)
      this.pageNum=val;
      for(let i in this.form){
        console.log(i)
        this.form[i]=''
      }
      console.log(this.form)
      this.getList()
      // 当前页 改变
    }
  }
};
</script>

<style lang="scss" scoped>
.storePage {
  text-align: left;
  .develop {
    width: 940px;
    border-radius: 4px;
    background: #fff;
    margin: 20px auto;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 30px;
      left: 0;
      width: 100%;
      font-family: 'HarmonyOS Sans SC';
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 35px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .inpbox {
      text-align: center;
      margin-bottom: 20px;
      .input1 {
        width: 528px;
        border-radius: 4px 0 0 4px;
        input {
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .btn {
      background: #ffe800;
      color: #4c0104;
      border-radius: 0 4px 4px 0;
    }
    .select {
      width: 140px;
      margin-right: 20px;
    }
    .input2 {
      width: 400px;
    }
    .storelist {
      width: 876px;
      margin: 0 auto;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      tr {
        td {
          &:nth-child(1) {
            color: #7a7a7a;
          }
        }
      }
    }
    /* 门店数据更新备注：醒目提示框，与表格等宽 */
    .data-update-note {
      width: 876px;
      margin: 14px auto 0;
      padding: 12px 16px;
      box-sizing: border-box;
      background: #fff7e6;
      border: 1px solid #ffd591;
      border-radius: 6px;
      font-size: 12px;
      color: #874d00;
      line-height: 1.8;
      text-align: left;

      .note-title {
        margin: 0 0 4px;
        font-size: 13px;
        font-weight: 600;
        color: #d46b08;
      }
      .note-text {
        margin: 0 0 6px;
      }
      .note-detail {
        margin: 0;
        color: #ad6800;
        strong {
          color: #d4380d;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.inpbox {
  .input1 {
    input {
      border-radius: 4px 0 0 4px;
      border-right: none;
    }
  }
}
.storelist {
  width: 876px;
  margin: 0 auto;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  .el-table::before {
    height: 0;
  }
  tr {
    th {
      &:nth-child(1) {
        > div {
          padding: 0 0 0 50px;
        }
      }
      > div {
        color: #333333;
      }
    }
    td {
      border: none;
      padding: 0 0 20px;

      &:nth-child(1) {
        color: #333333;
        padding: 0 0 20px 40px;
      }
      &:nth-child(2) {
        color: #7a7a7a;
      }
    }
    .btns {
      color: #ffb100;
    }
  }

  /* 移除table组件hover背景色 */
  .el-table__row:hover > td {
    background: #fff !important;
  }
  .el-table th.is-leaf {
    border: none;
  }

}
</style>
